import Constants from '@/Constants';
import React from 'react';
import EmptyLessonThumb from '../EmptyLessonThumb';
import './style.scss';

interface PropsType {
    imageSrc?: string;
    isFinished: boolean;
    isReproved?: boolean;
}

const CardItemThumb = ({ imageSrc, isFinished, isReproved = false }: PropsType) => {
    return (
        <div className="card-item-thumb">
            {imageSrc ? <img alt="" className="card-item-thumb__img" src={imageSrc} /> : <EmptyLessonThumb />}
            {isFinished && (
                <div className="conclusion-check concluded">
                    <i className="material-icons"> {Constants.icons.CHECK}</i>
                </div>
            )}
            {isReproved && (
                <div className="conclusion-check concluded">
                    <i className="material-icons"> {Constants.icons.CLOSE}</i>
                </div>
            )}
        </div>
    );
};

export default CardItemThumb;
